var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer{margin-top:0}#delivery_select{background-color:#fff!important}.vue-simple-suggest.designed .input-wrapper input{-webkit-transition:none!important;-moz-transition:none!important;transition:none!important}.vue-simple-suggest.designed.proccessing .input-wrapper input{background-image:url(" + escape(require("../assets/img/ajax-loader.gif")) + ");background-size:20px;background-position:15px;background-repeat:no-repeat}.delivery_inner input[type=submit][disabled]{opacity:.7;cursor:no-drop}.delivery_inner .error_tx.hidden{display:none}", ""]);

// exports
